class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



(function () {

  const GIFTBOX_VARIANT_ID = 52635685454189;

  const TRIGGER_PRODUCTS = [
    14904933613933,
    14904932139373,
    14904930664813
  ];

  let isProcessingGiftBox = false;



  /* ===============================
  AGREGAR / ELIMINAR REGALO
  =============================== */

  window.ensureGiftBox = async function ensureGiftBox() {

    if (isProcessingGiftBox) return;
    isProcessingGiftBox = true;

    try {

      const cart = await fetch('/cart.js').then(r => r.json());




      const giftIndex = cart.items.findIndex(
        i => i.variant_id === GIFTBOX_VARIANT_ID && i.properties?._promo
      );

      const giftItem = cart.items[giftIndex];

      const hasTriggerProduct = cart.items.some(item =>
        TRIGGER_PRODUCTS.includes(Number(item.product_id))
      );

      const cartDrawer = document.querySelector('cart-drawer');
      const cartItemsEl = document.querySelector('cart-items');

      const drawerSections = cartDrawer?.getSectionsToRender?.() || [];
      const pageSections = cartItemsEl?.getSectionsToRender?.() || [];

      const sectionIds = [...drawerSections, ...pageSections].map(s => s.section || s.id);



      /* AGREGAR REGALO */

      if (hasTriggerProduct && !giftItem) {

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: GIFTBOX_VARIANT_ID,
              quantity: 1,
              properties: { _promo: "Regalo promo X+Y" }
            }]
          })
        });

        await refreshCartSections(sectionIds);

      }



      /* ELIMINAR REGALO */

      if (!hasTriggerProduct && giftItem) {

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: giftIndex + 1,
            quantity: 0
          })
        });

        await refreshCartSections(sectionIds);

      }

    } catch (err) {

      console.error('[GiftBox]', err);

    } finally {

      setTimeout(() => {
        isProcessingGiftBox = false;
      }, 400);

    }

  };



  /* ===============================
  REFRESH CART
  =============================== */

  async function refreshCartSections(sectionIds) {

    const cartDrawer = document.querySelector('cart-drawer');
    const cartItemsEl = document.querySelector('cart-items');

    const allSections = [
      ...(cartDrawer?.getSectionsToRender?.() || []),
      ...(cartItemsEl?.getSectionsToRender?.() || [])
    ];

    const sectionsResponse = await fetch(
      `${routes.cart_url}?sections=${sectionIds.join(',')}&sections_url=${window.location.pathname}`,
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    ).then(r => r.json());



    /* actualizar cart drawer */

    if (cartDrawer && sectionsResponse) {
      cartDrawer.renderContents({ sections: sectionsResponse });
    }



    /* actualizar cart page */

    if (cartItemsEl && sectionsResponse) {

      allSections.forEach(section => {

        const html = sectionsResponse[section.section];
        if (!html) return;

        const elementToReplace =
          document.getElementById(section.id)?.querySelector(section.selector) ||
          document.getElementById(section.id);

        if (elementToReplace) {

          elementToReplace.innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(section.selector).innerHTML;

        }

      });

    }

  }



  /* ===============================
  MOSTRAR BOTON CAJA EXTRA
  =============================== */

  window.toggleGiftboxExtra = async function toggleGiftboxExtra() {

    const cart = await fetch('/cart.js').then(r => r.json());

    const wrapper = document.getElementById('giftbox-extra-wrapper');
    if (!wrapper) return;

    wrapper.classList.toggle('hidden', cart.item_count === 0);

  };



  /* ===============================
  EVENTO BOTON CAJA EXTRA
  (event delegation para no perderlo)
  =============================== */

  document.addEventListener('click', async (e) => {

    const btn = e.target.closest('#lanni-giftbox-extra-btn');
    if (!btn) return;

    const qtyInput = document.getElementById('lanni-giftbox-extra-qty');

    const qty = parseInt(qtyInput?.value || '1', 10);
    const variantId = btn.getAttribute('data-variant-id');

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    });

    const cartDrawer = document.querySelector('cart-drawer');
    const cartItemsEl = document.querySelector('cart-items');

    const drawerSections = cartDrawer?.getSectionsToRender?.() || [];
    const pageSections = cartItemsEl?.getSectionsToRender?.() || [];

    const sectionIds = [...drawerSections, ...pageSections].map(s => s.section || s.id);

    await refreshCartSections(sectionIds);

    toggleGiftboxExtra();

  });



  /* ===============================
  EVENTOS DEL CARRITO
  =============================== */

  document.addEventListener('change', (e) => {

    if (e.target.closest('cart-items, cart-drawer')) {

      ensureGiftBox();
      toggleGiftboxExtra();

    }

  });



  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {

subscribe(PUB_SUB_EVENTS.cartUpdate, () => {

  setTimeout(() => {
    ensureGiftBox();
    toggleGiftboxExtra();
  }, 200);

});

  }



  /* ===============================
  INIT
  =============================== */

  document.addEventListener('DOMContentLoaded', () => {

    toggleGiftboxExtra();

    setTimeout(() => {
      ensureGiftBox();
    }, 200);

  });

})();